export default __webpack_public_path__ + "static/media/hover-imatge-ensenyant@2x.7c6ae7b5.jpg";